module.exports = __webpack_public_path__ + "assets/icons/truck-nonactive.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/truck-nonactive.png
// module id = ./src/styles/icons/emojies/truck-nonactive.png
// module chunks = 0